export const SITE_TITLE = {
  DEFAULT: 'The Shops at Chase - chase.com',
  MOBILE: 'The Shops at Chase',
};
